export default function({ state, commit, dispatch, rootGetters, getters }, query) {
    if (typeof query.id !== 'string' || state.loadingPatient[query.id])
        return
    commit('startLoadingPatient', query.id)
    let providerId = query.providerId ? query.providerId : state.id
    // Get provider id for patient
    if(state.providerPatients.length === 1)
        providerId = state.providerPatients[0].id
    if(!providerId)
        providerId = state.providerPatients
            .flatMap((provider) => provider.patient.map((patient) => ({id: patient.id, providerId: [provider.id]})))
            .find(({ id }) => id === query.id)
            .providerId
    dispatch('loadPatientAnalytics', query)
    return Promise.all([
        dispatch('get', {
            url: '/provider/' + providerId + '/patient/' + query.id + (state.id ? '' : '/summary') + '?exclude=content'
        }, {
            root: true
        }),
        dispatch('get', {
            url: '/provider/' + providerId + '/patient/' + query.id + (state.id ? '' : '/summary') + '?include=content'
        }, {
            root: true
        })
    ])
    .then(([eventData, contentData]) => {
        const response = {
            ...eventData,
            ...contentData
        }
        const events = response.event
        let eventsWithType = events.filter(event => event.type)

        if(response.patient && 'survey' in response.patient)
            delete response.patient.survey
        
        // storing only events with type
        response.event = eventsWithType

        commit('updatePatient', {...response, reset: true} )
        if (response.content) {
            commit('content/cache', response.content, { root: true })
        }

        try {
            const patientInfo =  getters.getPatientList.find(({ id }) => response.patient.id === id)
            if(patientInfo.email !== response.patient.email || patientInfo.name !== response.patient.name || patientInfo.phone !== response.patient.phone) {
                commit('addProviderPatients', {
                    id: Array.isArray(providerId) ? providerId[0] : providerId,
                    patient: [response.patient]
                })
            }
        } catch (error) {
            console.error('Problem setting patient ', error)
        }
        
        // storing article ids with content
        const getContent = rootGetters['content/getContent']
        if(response.message) {
            try {
                let articleObj = {
                    type: 'article',
                    id: response.message.map((message) => {
                        if(message.ref_type && message.ref_id) {
                            if(typeof message.ref_type === 'string' && message.ref_type === 'article' && !getContent('article', message.ref_id)) {
                                return message.ref_id
                            }
                            if(Array.isArray(message.ref_type) && Array.isArray(message.ref_id)) {
                                return message.ref_id.filter((id, index) => message.ref_type[index] === 'article' && !getContent('article', id)).join(',')
                            }
                        }
                    }).filter(Boolean).join(','),
                    attr: 'title'
                }
                if(articleObj.id !== '')
                    dispatch('content/loadContent', articleObj, { root: true })
            } catch (error) {
                console.error("Problem getting aticle content", error)
            }
           
        }

        commit('finishLoadingPatient', query.id)
    })
    .catch((error) => {
        commit('finishLoadingPatient', query.id)
        if(error.status === 401)
            dispatch('auth/logout', null, { root: true})
        throw error
    })
}
